import { useIntl } from 'react-intl'
import { projectsAPI } from '../../../../../proxyConfig/apiUrls'
import { useAccessSearchParam } from '../../../../zustand/authentication/use-auth-store'
import ButtonComponent from '../../../stories/atoms/button'
import {
  buttonSizeOptions,
  buttonTypeOptions,
  buttonVariantOptions
} from '../../../stories/atoms/button/constants'
import { Settings } from '../../../stories/atoms/icons/core'
import { iconSizeOptions } from '../../../stories/atoms/icons/icons-sizes'
import { CancelBold } from '../../../stories/atoms/icons/image-overlay'
import { Pins, Plans, Tasks } from '../../../stories/atoms/icons/menu'
import colorsOptions from '../../../stories/fundamentals/colors-styles/constants'

import {
  HeaderButtons,
  HeaderContainer,
  ProjectIdentification,
  ProjectCompany,
  ProjectTitle,
  ProjectSummaryContainer
} from '../../styled-components'
import { useHistory } from 'react-router-dom'
import HeaderSummaryItem from './header-summary-item'
import PropTypes from 'prop-types'

const pisListParameters = {
  viewType: 'list',
  noPlan: 'noPlan',
  pinId: 'Any',
  tab: 'Active',
  pinOption: 'LastModified_DESC',
  page: '0',
  size: '25'
}

const ProjectInfoPanelHeader = ({
  projectDetails = null,
  projectPlans = null,
  projectPins = null,
  projectTasks = null,
  projectPinsIsLoading = false,
  projectTasksIsLoading = false,
  projectPlansIsLoading = false,
  userPermissions = [],
  onClose
}) => {
  const accessToken = useAccessSearchParam()
  const history = useHistory()
  const { formatMessage } = useIntl()

  const { id, name, organisationName } = projectDetails || {}
  const imageSrc = `${projectsAPI}/${id}/logo${accessToken()}`

  const numberOfPlans = projectPlans?.totalElements ?? 0
  const numberOfPins = projectPins?.totalElements ?? 0
  const numberOfTasks = projectTasks?.totalElements ?? 0

  const canGrantAdmin = userPermissions.includes('GrantAdmin')

  const handleOpenProjectSettings = () => {
    history.push(`/project/settings/${id}`)
  }

  const handleOpenProjectTaskList = () => {
    history.push(`/project/${id}/tasks`)
  }

  const handleOpenProjectPinList = () => {
    const parameters = Object.values(pisListParameters).join('/')
    history.push(`/project/${id}/pins/${parameters}`)
  }

  const hanelOpenProjectPlanList = () => {
    history.push(`/project/${id}`)
  }

  return (
    <HeaderContainer background={imageSrc}>
      <HeaderButtons>
        {canGrantAdmin && (
          <ButtonComponent
            buttonType={buttonTypeOptions['ICON-ONLY']}
            variant={buttonVariantOptions['IMAGE-OVERLAY']}
            size={buttonSizeOptions.SMALL}
            onClick={handleOpenProjectSettings}
          >
            <Settings stroke={colorsOptions.greys.white} />
          </ButtonComponent>
        )}
        <ButtonComponent
          buttonType={buttonTypeOptions['ICON-ONLY']}
          variant={buttonVariantOptions['IMAGE-OVERLAY']}
          size={buttonSizeOptions.SMALL}
          onClick={onClose}
        >
          <CancelBold stroke={colorsOptions.greys.white} />
        </ButtonComponent>
      </HeaderButtons>
      <ProjectIdentification>
        <ProjectCompany>{organisationName}</ProjectCompany>
        <ProjectTitle>{name}</ProjectTitle>
      </ProjectIdentification>

      <ProjectSummaryContainer>
        <HeaderSummaryItem
          onClick={handleOpenProjectPinList}
          Icon={<Pins size={iconSizeOptions['ICON-XL']} />}
          label={formatMessage({ id: 'pins' })}
          value={projectPinsIsLoading ? '-' : numberOfPins}
        />

        <HeaderSummaryItem
          onClick={handleOpenProjectTaskList}
          Icon={<Tasks size={iconSizeOptions['ICON-XL']} />}
          label={formatMessage({ id: 'tasks' })}
          value={projectTasksIsLoading ? '-' : numberOfTasks}
        />

        <HeaderSummaryItem
          onClick={hanelOpenProjectPlanList}
          Icon={<Plans size={iconSizeOptions['ICON-XL']} />}
          label={formatMessage({ id: 'plans' })}
          value={projectPlansIsLoading ? '-' : numberOfPlans}
        />
      </ProjectSummaryContainer>
    </HeaderContainer>
  )
}

ProjectInfoPanelHeader.propTypes = {
  projectDetails: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    organisationName: PropTypes.string
  }),
  projectPlans: PropTypes.shape({
    totalElements: PropTypes.number
  }),
  projectPins: PropTypes.shape({
    totalElements: PropTypes.number
  }),
  projectTasks: PropTypes.shape({
    totalElements: PropTypes.number
  }),
  projectPinsIsLoading: PropTypes.bool,
  projectTasksIsLoading: PropTypes.bool,
  projectPlansIsLoading: PropTypes.bool,
  userPermissions: PropTypes.arrayOf(PropTypes.string),
  onClose: PropTypes.func
}

export default ProjectInfoPanelHeader
